var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.form)?_c('HealthHistoryForm',{attrs:{"formType":_vm.formType}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }